/**
 * A percentage with its sign written out ("+12.5%", "-3.0%", "0.0%"), so a
 * gain or a loss never relies on colour alone.
 */
export function signedPercent(value, digits = 1) {
  const n = Number(value) || 0;
  return `${n > 0 ? '+' : ''}${n.toFixed(digits)}%`;
}

/** "+" for a gain, nothing otherwise: a negative amount already carries its "-". */
export function signPrefix(value) {
  return (Number(value) || 0) > 0 ? '+' : '';
}
